var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('printTicketBody',_vm._b({},'printTicketBody',_vm.$props,false)),(_vm.printCopy)?_c('printTicketBody',_vm._b({attrs:{"isCopy":true}},'printTicketBody',_vm.$props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }